const DistanceHelper = {
    swimDistance: distance => {
        switch(distance) {
            case 'pool-sprint':
                return 400;
            case 'sprint':
                return 750;
            case 'standard':
                return 1500;
            case 'middle':
                return 1900;
            case 'full':
                return 3800;
        }
    },
    bikeDistance: distance => {
        switch(distance) {
            case 'pool-sprint':
                return 20;
            case 'sprint':
                return 20;
            case 'standard':
                return 40;
            case 'middle':
                return 90;
            case 'full':
                return 180;
        }
    },
    runDistance: distance => {
        switch(distance) {
            case 'pool-sprint':
                return 5;
            case 'sprint':
                return 5;
            case 'standard':
                return 10;
            case 'middle':
                return 21.1;
            case 'full':
                return 42.2;
        }
    }
};

export default DistanceHelper;
